export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11004.873faf91.jpg";